<template>
  <article>
    <div class="dataForm">
      <div class="dataForm__item">
        <div class="dataForm__name">ID</div>
        <el-input v-model="detail.etid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">标题</div>
        <el-input v-model="detail.title" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">icon</div>
        <div class="headimg-container relative" style="width:250px">
          <uploadHeadImage :url.sync="detail.icon" :itype="5"></uploadHeadImage>
        </div>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">负责人</div>
        <operSelect v-model="detail.opid" :lists.sync="operLists" :need-edit="true"/>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">下家</div>
        <el-select class="filter__input" size="mini" v-model="detail.acid" filterable>
          <el-option :label="item.name" :value="item.acid" v-for="(item, index) in adChnLists" :key="index"></el-option>
        </el-select>
        <div class="dataForm__item ml-10">
          <el-button size="mini" @click="adChnDialog = !adChnDialog">添加下家</el-button>
        </div>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">收货地址</div>
        <el-radio-group v-model="detail.acaid">
          <el-radio v-for="item in addressLists" :label="item.acaid" :key="item.acaid" v-if="item.status">{{item.address}}</el-radio>
        </el-radio-group>
        <i class="el-icon-edit ml-20" @click="editAddress" v-if="detail.acid !== ''"></i>
        <el-button text size="mini" class="ml-20" @click="detail.acaid = 0">取消选择</el-button>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">项目</div>
        <el-select placeholder="请选择项目" size="mini" v-model="detail.adid" filterable>
          <el-option v-for="item in adLists" :key="item.adid" :label="item.project" class="dataForm__input"  :value="item.adid"> </el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">底价折扣</div>
        <el-input v-model="detail.min_discount" placeholder="税后实际折扣" size="mini" style="width:200px" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
        <div class="ml-30 mr-20">用户折扣</div>
        <el-input v-model="detail.discount" placeholder="用户的折扣" size="mini" style="width:200px" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">口令墙</div>
        <el-select class="filter__input" size="mini" v-model="detail.awid" filterable>
          <el-option :label="item.title" :value="item.awid" v-for="(item, index) in watchwordLists" :key="index"></el-option>
        </el-select>
        <el-button class="ml-10" icon="el-icon-refresh-right" circle size="mini" @click="handleAwidChange"></el-button>
      </div>
      <!--
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">底价折扣</div>
        <el-input v-model="detail.min_discount" placeholder="税后实际折扣" size="mini" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">用户折扣</div>
        <el-input v-model="detail.discount" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
      </div>
      -->
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">投放时间</div>
        <el-date-picker v-model="dateTime" type="datetimerange" placeholder="选择时间范围" align="right" size="mini" class="date">
        </el-date-picker>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">总单数</div>
        <el-input v-model="detail.quota" @input="(v)=>(detail.quota=v.replace(/[^\d]/g,''))" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">单</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">每日单数</div>
        <el-input v-model="detail.tquota" @input="(v)=>(detail.tquota=v.replace(/[^\d]/g,''))" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">单</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">拍手费</div>
        <el-input v-model="detail.agency_fees" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否开发票</div>
        <el-radio-group v-model="detail.is_invoice">
          <div class="dib mr-20">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16" v-if="detail.is_invoice">
        <div class="dataForm__name">发票奖励</div>
        <el-input v-model="detail.bonus" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16" v-if="detail.is_invoice">
        <div class="dataForm__name">发票抬头</div>
        <invoiceTitleSelect v-model="detail.itid" :need-edit="true" />
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">要求</div>
        <el-input type="textarea" v-model="detail.demand" rows=3 placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">口令</div>
        <el-input type="textarea" v-model="detail.keyword" rows=4 placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>

      <div class="dataForm__item mt-16">
        <div class="dataForm__name">地址</div>
        <el-input type="textarea" v-model="detail.address" rows=5 placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">优惠券链接</div>
        <el-input type="textarea" v-model="detail.coupon_url" rows=2 placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">引导</div>
        <div>
            <div class="dataForm__item mt-16">
              <el-input type="textarea" v-model="detail.guide.first_desc" rows=4 placeholder="1.复制口令，进入直播间" size="mini" class="dataForm__input"></el-input>
              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.guide.first_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
            <div class="dataForm__item mt-16">
              <el-input type="textarea" v-model="detail.guide.secord_desc" rows=4 placeholder="2.直播间5号链接，选择" size="mini" class="dataForm__input"></el-input>
              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.guide.secord_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
            <div class="dataForm__item mt-16">
              <el-input type="textarea" v-model="detail.guide.third_desc" rows=4 placeholder="3.一号最多可下3单，一单5件，实付649，建议先提交自己地址后改地址" size="mini" class="dataForm__input"></el-input>
              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.guide.third_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
        </div>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">商品信息</div>
        <el-input v-model="detail.goods" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">备注</div>
        <el-input v-model="detail.remark" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">订单金额</div>
        <el-input v-model="detail.amount" @input="(v)=>(detail.amount=v.replace(/[^\d.]/g,''))" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">￥</template>
        </el-input>
      </div>
      <!--
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">单价</div>
        <el-input v-model="detail.price" @input="(v)=>(detail.price=v.replace(/[^\d.]/g,''))" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">￥</template>
        </el-input>
      </div>
      -->
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">应收单价</div>
        <el-input v-model="detail.income" @input="(v)=>(detail.income=v.replace(/[^\d.]/g,''))" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">￥</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">收货方式</div>
        <el-radio-group v-model="detail.receive_mode">
          <div class="dib mr-20">
            <el-radio :label="1">直下</el-radio>
            <el-radio :label="2">代转寄</el-radio>
            <el-radio :label="3">自己转寄</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否需要备注信息</div>
        <el-radio-group v-model="detail.extra">
          <div class="dib mr-20">
            <el-radio :label="0">不需要</el-radio>
            <el-radio :label="1">需要</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否收款</div>
        <el-radio-group v-model="detail.ieffect">
          <div class="dib mr-20">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">完成条件</div>
        <el-radio-group v-model="detail.condition">
          <div class="dib mr-20">
            <el-radio :label="0">默认</el-radio>
            <el-radio :label="1">不需要完成截图</el-radio>
            <el-radio :label="2">不需要报单截图</el-radio>
            <el-radio :label="3">不需要截图</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否展示在首页</div>
        <el-radio-group v-model="detail.home">
          <div class="dib mr-20">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">状态</div>
        <el-radio-group v-model="detail.status">
          <div class="dib mr-20">
            <el-radio :label="0">下架</el-radio>
            <el-radio :label="1">运行</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name"></div>
        <button class="blue-large-btn" @click="taskEdit">保存</button>
      </div>
    </div>
    <el-dialog title="下家编辑" :visible.sync="adChnDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">下家ID</div>
            <el-input v-model="adChnInfo.acid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">微信号</div>
            <el-input v-model="adChnInfo.wechat" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">下家名</div>
            <el-input v-model="adChnInfo.name" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="adChnEdit">保存</div>
          <div class="gray-large-btn" @click="adChnDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="地址编辑" :visible.sync="addressDialog" size="tiny" width="1000px" center>
      <div class="mb-20">
        <el-table ref="dataTable" :data="addressLists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="">
          <el-table-column prop="acaid" label="ID" width="" align="center">
          </el-table-column>
          <el-table-column prop="acid" label="下家ID" width="" align="center">
          </el-table-column>
          <el-table-column prop="address" label="地址" width="400" align="center">
            <template slot-scope="scope">
              <div class="flex jcc">
                <el-input type="textarea" :rows="2"  v-model="scope.row.address" placeholder="" size="mini" class="dataForm__input"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sold" label="状态" width="200" align="center">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.status">
                <div class="dib mr-20">
                  <el-radio :label="0">失效</el-radio>
                  <el-radio :label="1">运行</el-radio>
                </div>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="flex jcc">
                <button class="blue-small-btn" @click="addressItmeEdit(scope.$index)">保存</button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="fs-25 flex jcc aic mb-20">地址新增</div>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">ID</div>
            <el-input v-model="addressInfo.acaid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">下家ID</div>
            <el-select class="filter__input" size="mini" v-model="addressInfo.acid" :disabled="true">
              <el-option :label="item.name" :value="item.acid" v-for="(item, index) in adChnLists" :key="index"></el-option>
            </el-select>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">地址</div>
            <el-input type="textarea" :rows="4" v-model="addressInfo.address" placeholder="填写地址" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="addressEdit">保存</div>
          <div class="gray-large-btn" @click="addressDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import util from '../../../script/util'
import {taskDetail, taskEdit, adLists, adWatchwordLists, adChnLists, adChnEdit, adChnAddressEdit} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
import operSelect from '../../../components/data-select/operSelect.vue'
import invoiceTitleSelect from '../../../components/data-select/invoiceTitleSelect.vue'
export default {
  name: 'taskEdit',
  components: {
    uploadHeadImage,
    operSelect,
    invoiceTitleSelect
  },
  data () {
    return {
      opid: '',
      etid: 0,
      copy_etid: 0,
      detail: {
        etid: 0,
        title: '',
        icon: '',
        opid: '',
        acid: '',
        adid: 0,
        awid: 0,
        acaid: 0,
        itid: 0,
        min_discount: '',
        discount: '',
        home: 1,
        quota: '',
        tquota: '',
        agency_fees: 0,
        end_time: '',
        start_time: '',
        coupon_url: '',
        address: '{replace}',
        demand: '',
        keyword: '',
        tutor: [],
        guide: {
          first_desc: '1.复制口令，进入直播间',
          first_img: '',
          secord_desc: '',
          secord_img: '',
          third_desc: '',
          third_img: ''
        },
        agent: '',
        extra: 0,
        goods: '',
        remark: '',
        receive_mode: 3,
        amount: '',
        income: '',
        price: '',
        ieffect: 0,
        condition: 0,
        is_invoice: 0,
        bonus: 0,
        status: 1
      },
      dialog: false,
      dateTime: '',
      adLists: [],
      operLists: [],
      watchwordLists: [],
      statusList: [
        {
          name: '正常',
          value: 1
        },
        {
          name: '停止',
          value: 0
        },
        {
          name: '完结',
          value: 2
        }
      ],
      adChnLists: [],
      adChnDialog: false,
      adChnInfo: {
        acid: 0,
        name: '',
        wechat: ''
      },
      addressDialog: false,
      acaidLists: [],
      addressLists: [],
      addressInfo: {
        acaid: 0,
        acid: '',
        address: ''
      }
    }
  },
  methods: {
    dateTimeChange () {
      if (this.dateTime) {
        this.detail.start_time = parseInt(new Date(this.dateTime[0]).getTime() / 1000)
        this.detail.end_time = parseInt(new Date(this.dateTime[1]).getTime() / 1000)
      } else {
        this.detail.start_time = ''
        this.detail.end_time = ''
      }
    },
    handleAwidChange () {
      this.watchwordLists.forEach((item) => {
        if (item.awid === this.detail.awid) {
          this.detail.min_discount = item.min_discount
          this.detail.keyword = item.keyword
          this.detail.demand = item.demand
          this.detail.address = item.address
          this.detail.coupon_url = item.coupon_url
          this.detail.guide = item.guide
          this.detail.goods = item.goods
          this.detail.agency_fees = item.agency_fees
          this.detail.amount = item.amount
          this.detail.income = item.income
        }
      })
    },
    handleAdidChange () {
      this.adLists.forEach((item) => {
        if (item.adid === this.detail.adid) {
          this.detail.min_discount = item.min_discount
          this.detail.discount = item.discount
        }
      })
    },
    handleAcidChange () {
      if (this.detail.acid === '') {
        return
      }

      this.adChnLists.forEach((item) => {
        if (item.acid === this.detail.acid) {
          this.addressLists = item.address_lists
        }
      })
    },
    editAddress () {
      if (this.detail.acid === '') {
        return
      }
      this.addressDialog = true
      this.addressInfo['acaid'] = 0
      this.addressInfo['acid'] = this.detail.acid
      this.addressInfo['address'] = ''
    },
    getAdLists () {
      let params = {
        market: 3,
        l: 500,
        p: 1
      }
      adLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.adLists = data.d.lists.map((item, index) => {
            return {
              title: item.title,
              adid: item.adid,
              project: item.title + '(' + item.adid + ')',
              discount: item.discount,
              min_discount: item.min_discount,
              aver_discount: item.aver_discount
            }
          })
        }
      })
    },
    getAdWatchwordLists () {
      let params = {
        l: 500,
        p: 1
      }
      adWatchwordLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.watchwordLists = data.d.lists

          this.watchwordLists.unshift({
            title: '不绑定',
            awid: 0
          })
        }
      })
    },
    getAdChnLists () {
      let params = {
        l: 500,
        p: 1,
        opid: this.opid
      }

      if ([2, 4, 16].includes(this.opid)) {
        delete params.opid
      }

      adChnLists(params).then((res) => {
        let data = res.data || {c: -1}

        if (!data.c) {
          this.adChnLists = data.d.lists.map((item, index) => {
            return {
              name: item.name,
              acid: item.acid,
              address_lists: item.address_lists
            }
          })

          this.handleAcidChange()
        }
      })
    },
    adChnEdit () {
      let params = {
        acid: this.adChnInfo.acid,
        opid: this.opid,
        wechat: this.adChnInfo.wechat,
        name: this.adChnInfo.name
      }

      let content = ''

      if (params['name'] === '') {
        content = '名字不能为空'
      }

      if (params['wechat'] === '') {
        content = '微信名不能为空'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      adChnEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.adChnDialog = false
          this.getAdChnLists()

          for (let key in this.adChnInfo) {
            this.adChnInfo[key] = ''
          }
          this.adChnInfo.acid = 0
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    addressItmeEdit (index) {
      let params = {
        acaid: this.addressLists[index]['acaid'],
        address: this.addressLists[index]['address'],
        status: this.addressLists[index]['status']
      }

      this.adChnAddressEdit(params)
    },
    addressEdit () {
      let params = {
        acaid: this.addressInfo.acaid,
        acid: this.addressInfo.acid,
        address: this.addressInfo.address
      }

      this.adChnAddressEdit(params)
    },
    adChnAddressEdit (params) {
      let content = ''

      if (params['address'] === '') {
        content = '地址不能为空'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      adChnAddressEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.addressDialog = false
          this.getAdChnLists()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    // 公众号详情
    taskDetail (etid) {
      let params = {
        etid: etid
      }
      this.loading = true
      taskDetail(params).then((res) => {
        let data = res.data || {c: -1}
        console.log(data)
        if (!data.c) {
          this.dateTime = [data.d.start_time * 1000, data.d.end_time * 1000]
          this.detail = data.d

          this.detail.etid = this.etid
          this.addressLists = data.d.address_lists
        }
        this.loading = false
      })
    },
    taskEdit () {
      let params = util.cloneObj(this.detail)

      params['guide'] = JSON.stringify(params['guide'])
      params['amount'] = parseFloat(params['amount'])
      params['price'] = parseFloat(params['price'])
      params['income'] = parseFloat(params['income'])

      let content = ''

      if (params['opid'] === '') {
        content = '请选择负责人'
      }

      if (params['title'] === '') {
        content = '请填写标题'
      }

      if (params['total'] === '') {
        content = '请设置总额度'
      }

      if (params['etid'] === 0 && params['min_discount'] === '100') {
        content = '低价折扣不能为100'
      }

      if (params['amount'] === '') {
        content = '请填写订单金额'
      }

      if (params['income'] === '' || util.isZero(params['income'])) {
        content = '请填写应收'
      }

      if (params['keyword'] === '') {
        content = '请填写口令'
      }

      if (params['demand'] === '') {
        content = '请填写要求'
      }

      if (params['is_invoice'] === 0) {
        params['bonus'] = 0
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      taskEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.$router.push('/taskList')
        } else {
          this.$notify({
            title: '失败',
            message: '服务器出错了',
            type: 'error'
          })
        }
      })
    }
  },
  watch: {
    'detail.awid': 'handleAwidChange',
    'detail.adid': 'handleAdidChange',
    'detail.acid': {
      handler: function (newValue, oldValue) {
        if (oldValue !== '') {
          this.detail.acaid = 0
        }

        this.handleAcidChange()
      }
    },
    'dateTime': 'dateTimeChange'
  },
  mounted () {
    this.opid = parseInt(window.localStorage.getItem('opid'))

    this.etid = parseInt(this.$route.query.etid || 0)
    if (this.etid) {
      this.taskDetail(this.etid)
    }

    // 复制
    this.copy_etid = parseInt(this.$route.query.copy_etid || 0)
    if (this.copy_etid) {
      this.taskDetail(this.copy_etid)
    }

    this.getAdLists()
    this.getAdWatchwordLists()
    this.getAdChnLists()
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/earn/taskEdit.vue